import React, { Component } from "react";
import wavingHandImage from "../../images/waving-hand.svg";
// import handsClap from "../../images/handsClap.png";
import simplify360 from "../../images/simplify360_logo.png";
import "./InitialFormStyleSheet.css";

class InitialChannelHeader extends Component {
  render() {
    return (
      <div className="s360-initial-channel-header" style={this.headerStyle()}>
        {/* <img style={{ width: "40px", height: "48px", right: "52px",top:"30px", cursor: "pointer",position:'absolute' }} src={simplify360}  alt="/"></img> */}
        <div className="s360-initial-form-header-message">
          <div
            className="s360-initial-form-header-salutation-message"
            style={this.headerTextStyle()}
          >
            <h4 style={{ fontFamily: "poppins",fontWeight:'bold' }}>
              {this.props.config.configDetails.brandMessage.toString()}
            </h4>
            {/* <img
              style={{
                width: "24px",
                height:
                  this.props.config.designDetails.headerIcon === " "
                    ? "48px"
                    : "24px",
                marginRight: "48px",
                marginLeft: "8px",
                marginTop:
                  this.props.config.designDetails.headerIcon === " "
                    ? "-10px"
                    : "2px",
                cursor: "pointer",
              }}
              src={
                this.props.config.designDetails.headerIcon !== "handsClap"
                  ? handsClap
                  : wavingHandImage
              }
              alt="/"
            ></img> */}

            <div className="s360-default-header-icon" onClick={this.onClose} role="button" tabIndex={0} aria-label="Close chat" onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.onClose(); } }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53"
                viewBox="0 0 13.624 8.209"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  fill="#1f175c"
                />
              </svg>
            </div>
          </div>
        </div>

        <div
          className="s360-initial-form-header-welcome-message"
          style={this.headerTextStyle()}
        >
          {this.props.config.configDetails.brandWelcomeMessage}
        </div>

        <div
          className="s360-initial-channel-sub-header-message"
          style={this.subHeaderStyle()}
        >
          {this.props.config.configDetails.brandChannelSubMessage}
        </div>
      </div>
    );
  }

  subHeaderStyle = () => {
    return {
      fontFamily: this.props.config.designDetails.messageFont,
      fontSize: this.props.config.designDetails.messageFontSize + "px",
      color: this.props.config.designDetails.messageFontColor,
    };
  };



  onClose = () => {
    window.parent.postMessage(
      {
        iframeMinimized:'true'
      },
      "*"
    )


    this.props.actions &&
      this.props.actions.onHideChatWindow &&
      this.props.actions.onHideChatWindow();
  };

  headerStyle = () => {
    return {
      background:
        this.props.config.designDetails.headerBackgroundImage !== undefined &&
        this.props.config.designDetails.headerBackgroundImage !== ""
          ? "url(" + this.props.config.designDetails.headerBackgroundImage + ")"
          : this.props.config.designDetails.headerTopColor,
    };
  };

  headerTextStyle = () => {
    return {
      color: this.props.config.designDetails.headerFontColor,
      fontFamily: this.props.config.designDetails.headerFont,
      fontSize: this.props.config.designDetails.headerFontSize,
      // background: this.props.config.designDetails.headerBackgroundImage !== undefined && this.props.config.designDetails.headerBackgroundImage !== ""?("url("+this.props.config.designDetails.headerBackgroundImage+")"):this.props.config.designDetails.headerTopColor,
    };
  };
}

export default InitialChannelHeader;
